const Layout = () => import( "@/views/Layout");
const BookRoom = () => import(/* webpackChunkName: "home" */ "../views/home/BookRoom.vue");

export default [
    {
        path: "/room",
        component: Layout,
        meta: {
            title: '客房',
            titleEn: 'Room'
        },
        children: [
            {
                path: '',
                component: BookRoom
            }
        ]
    }
]